module.exports = __webpack_public_path__ + "img/guide2.96613ccd.jpg";